

import { ROUTES } from "../../../../module/constants";
import { generalConst } from "../../../../module/globalInterface";

export const PWD_MGMT_CONSOLE_ADMIN_URLS: generalConst = {
  BASE_URL: ROUTES.ADMIN_PWD_MGMT,
  STEP_TWO: `${ROUTES.ADMIN_PWD_MGMT}/stepTwo`,
};

export const STATE_IDENTIFIER = {
  STEP_ONE: "stepOne",
    PROPAGATIONS: "propagations",
    DEL_STATE: "deleteState",
    ADD_EDIT_STATE: "addEditState",
};

export interface IPropagation {
  propagationId: string | null,
  sourceTargetId: string,
  sourceIdentitySystemId: string,
  destTargetId: string,
  destIdentitySystemId: string,
};

export interface IPropagationStd {
  id: string | null,
  sourceTargetId: string,
  sourceIdentitySystemId: string,
  destTargetId: string,
  destIdentitySystemId: string,
};